module.exports = __webpack_public_path__ + "static/media/map-icon.ba59728b.svg";